import eHorizonImg from "../../../assets/images/Events/E-Horizon-2025.jpg";
import annualDayImg from "../../../assets/images/Events/Annual Day.png";
import sportsDayImg from "../../../assets/images/Events/Sports Day.jpg";
import swaramImg from "../../../assets/images/Events/Swaram 2025.jpg";

const eventsData = [
    {
        id: 1,
        image: eHorizonImg,
        date: "September 13, 2025",
        title: "E-Horizon 2025 - Technical Symposium",
    },
    {
        id: 2,
        image: swaramImg,
        date: "September 13, 2025",
        title: "Swaram 2025 - Cultural Fest",
    },
    {
        id: 3,
        image: sportsDayImg,
        date: "September 12, 2025",
        title: "Annual Sports Day Celebration",
    },
    {
        id: 4,
        image: annualDayImg,
        date: "September 10, 2025",
        title: "College Annual Day Function",
    },
];

export default eventsData;
